import m from "react";
import { useAtom as s } from "jotai";
import { alertAtom as u } from "./index51.mjs";
import { Modal as d } from "./index36.mjs";
const M = () => {
  const [t, e] = s(u);
  if (!t)
    return null;
  const { title: l, subTitle: r, icon: n, actions: a, onClose: o, children: c } = t, i = () => {
    e(null), o && o();
  };
  return /* @__PURE__ */ m.createElement(
    d,
    {
      title: l,
      subTitle: r,
      icon: n,
      actions: a,
      onClose: i
    },
    c
  );
};
export {
  M as AlertModal
};
